var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u642C\\u7816\\u83B7\\u5229",
    transform: "translate(-56.000000, -848.000000)",
    fill: "#20BD42",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD",
    transform: "translate(56.000000, 848.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    opacity: 0.301106771,
    cx: 36,
    cy: 36,
    r: 32.7272727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2627912,24.2894312 L52.2627912,16.3636364 L19.8118238,16.3636364 L19.8118238,24.2894312 L31.77547,24.2894312 L31.77547,29.4675758 C22.0503864,29.9049292 14.7272727,31.8219865 14.7272727,34.1220599 C14.7272727,36.4221897 22.0503299,38.339134 31.77547,38.7765439 L31.77547,55.3946742 L40.2992015,55.3946742 L40.2992015,38.7726465 C49.9867799,38.3286845 57.2727273,36.4151292 57.2727273,34.1220034 C57.2727273,31.8285951 49.9867799,29.9144185 40.2992015,29.4710213 L40.2992015,24.2893748 L52.2627912,24.2893748 L52.2627912,24.2894312 Z M53.6088546,33.6538099 C53.6088546,35.1665567 47.9463057,36.4354634 40.2992015,36.7877523 L39.8050255,36.8087078 L39.7504057,36.8087078 L39.2870133,36.8257658 L39.2368558,36.8257658 C38.8921921,36.8375709 38.5433487,36.8476815 38.1900996,36.8556457 L38.1681839,36.8556457 L37.694342,36.8654739 L37.5604191,36.8654739 L37.1864969,36.8705009 L34.8185301,36.8705009 L34.4484488,36.8654739 L34.3198919,36.8654739 L33.8777939,36.8562106 L33.8292179,36.8562106 C33.3052184,36.8445184 32.7891267,36.8283641 32.2806603,36.8087078 L32.2739953,36.8087078 L31.7677882,36.7867921 C24.0825575,36.4398691 18.3835201,35.1665567 18.3835201,33.6465799 C18.3835201,32.1262643 24.0835177,30.8567363 31.7677882,30.5059724 L31.7677882,35.313132 C33.1017641,35.3826634 34.5208045,35.4207899 35.9925441,35.4207899 C37.4877246,35.4207899 38.9354022,35.3820421 40.2918586,35.3092911 L40.2918586,30.5202628 C47.9456279,30.871648 53.6088546,32.141176 53.6088546,33.6538099 L53.6088546,33.6538099 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProUsdt);
export default __webpack_public_path__ + "static/media/icon_pro_usdt.65586378e34a2b7bf03255bc4dc03d4a.svg";
export { ForwardRef as ReactComponent };